import styled from 'styled-components';
import { TStyledLabelProperties } from './label.types';

export const StyledLabel = styled.label<TStyledLabelProperties>`
    display: block;
    margin-bottom: ${({ marginBottom }) => marginBottom && '1.2rem'};
    font-weight: ${({ theme }) => theme.font.weight.bold};
`;
